export default {
  'A name is required for project category': {
    en: 'A name is required for project category',
    ja: 'A name is required for project category',
    et: 'A name is required for project category',
    lt: 'A name is required for project category',
    ch: 'A name is required for project category',
    ph: 'A name is required for project category',
  },
  'Add/Modify Project Category': {
    en: 'Add/Modify Project Category',
    ja: 'Add/Modify Project Category',
    et: 'Add/Modify Project Category',
    lt: 'Add/Modify Project Category',
    ch: 'Add/Modify Project Category',
    ph: 'Add/Modify Project Category',
  },
  All: {
    en: 'All',
    ja: '全て',
    et: 'Kõik',
    lt: 'All',
    ch: 'All',
    ph: 'All',
  },
  'All Categories': {
    en: 'All Categories',
    ja: 'All Categories',
    et: 'All Categories',
    lt: 'All Categories',
    ch: 'All Categories',
    ph: 'All Categories',
  },
  Approve: {
    en: 'Approve',
    ja: 'Approve',
    et: 'Approve',
    lt: 'Approve',
    ch: 'Approve',
    ph: 'Approve',
  },
  'Approve Requested Badges': {
    en: 'Approve Requested Badges',
    ja: 'Approve Requested Badges',
    et: 'Approve Requested Badges',
    lt: 'Approve Requested Badges',
    ch: 'Approve Requested Badges',
    ph: 'Approve Requested Badges',
  },
  'Approve/Reject Notes': {
    en: 'Approve/Reject Notes',
    ja: 'Approve/Reject Notes',
    et: 'Approve/Reject Notes',
    lt: 'Approve/Reject Notes',
    ch: 'Approve/Reject Notes',
    ph: 'Approve/Reject Notes',
  },
  'Are you sure that you want to change the project authors?': {
    en: 'Are you sure that you want to change the project authors?',
    ja: 'Are you sure that you want to change the project authors?',
    et: 'Are you sure that you want to change the project authors?',
    lt: 'Are you sure that you want to change the project authors?',
    ch: 'Are you sure that you want to change the project authors?',
    ph: 'Are you sure that you want to change the project authors?',
  },
  'Are you sure that you want to change the project owner?': {
    en: 'Are you sure that you want to change the project owner?',
    ja: 'Are you sure that you want to change the project owner?',
    et: 'Are you sure that you want to change the project owner?',
    lt: 'Are you sure that you want to change the project owner?',
    ch: 'Are you sure that you want to change the project owner?',
    ph: 'Are you sure that you want to change the project owner?',
  },
  Author: {
    en: 'Author',
    ja: '作者',
    et: 'Autor',
    lt: 'Author',
    ch: 'Author',
    ph: 'Author',
  },
  Authors: {
    en: 'Authors',
    ja: '作者',
    et: 'Autor',
    lt: 'Authors',
    ch: 'Authors',
    ph: 'Authors',
  },
  'Author User Link': {
    en: 'Author User Link',
    ja: 'Author User Link',
    et: 'Author User Link',
    lt: 'Author User Link',
    ch: 'Author User Link',
    ph: 'Author User Link',
  },
  'Badge Status': {
    en: 'Badge Status',
    ja: 'Badge Status',
    et: 'Badge Status',
    lt: 'Badge Status',
    ch: 'Badge Status',
    ph: 'Badge Status',
  },
  'Badge and Challenge Status': {
    en: 'Badge and Challenge Status',
    ja: 'Badge and Challenge Status',
    et: 'Badge and Challenge Status',
    lt: 'Badge and Challenge Status',
    ch: 'Badge and Challenge Status',
    ph: 'Badge and Challenge Status',
  },
  Badges: {
    en: 'Badges',
    ja: 'バッジ',
    et: 'Märgid',
    lt: 'Badges',
    ch: 'Badges',
    ph: 'Badges',
  },
  'Badges Awarded': {
    en: 'Badges Awarded',
    ja: 'Badges Awarded',
    et: 'Badges Awarded',
    lt: 'Badges Awarded',
    ch: 'Badges Awarded',
    ph: 'Badges Awarded',
  },
  'Badges Rejected': {
    en: 'Badges Rejected',
    ja: 'Badges Rejected',
    et: 'Badges Rejected',
    lt: 'Badges Rejected',
    ch: 'Badges Rejected',
    ph: 'Badges Rejected',
  },
  'Badges Resubmitted': {
    en: 'Badges Resubmitted',
    ja: 'Badges Resubmitted',
    et: 'Badges Resubmitted',
    lt: 'Badges Resubmitted',
    ch: 'Badges Resubmitted',
    ph: 'Badges Resubmitted',
  },
  'Badges Submitted': {
    en: 'Badges Submitted',
    ja: 'Badges Submitted',
    et: 'Badges Submitted',
    lt: 'Badges Submitted',
    ch: 'Badges Submitted',
    ph: 'Badges Submitted',
  },
  'Badges Unsubmitted': {
    en: 'Badges Unsubmitted',
    ja: 'Badges Unsubmitted',
    et: 'Badges Unsubmitted',
    lt: 'Badges Unsubmitted',
    ch: 'Badges Unsubmitted',
    ph: 'Badges Unsubmitted',
  },
  Branch: {
    en: 'Branch',
    ja: 'Branch',
    et: 'Branch',
    lt: 'Branch',
    ch: 'Branch',
    ph: 'Branch',
  },
  'Challenges Completed': {
    en: 'Challenges Completed',
    et: 'Challenges Completed',
    ja: 'Challenges Completed',
    lt: 'Challenges Completed',
    ch: 'Challenges Completed',
    ph: 'Challenges Completed',
  },
  Completed: {
    en: 'Completed',
    et: 'Completed',
    ja: 'Completed',
    lt: 'Completed',
    ch: 'Completed',
    ph: 'Completed',
  },
  'Change Project Author': {
    en: 'Change Project Author',
    ja: 'Change Project Author',
    et: 'Change Project Author',
    lt: 'Change Project Author',
    ch: 'Change Project Author',
    ph: 'Change Project Author',
  },
  'Choose a member to add to the coauthor list': {
    en: 'Choose a member to add to the coauthor list',
    ja: 'Choose a member to add to the coauthor list',
    et: 'Choose a member to add to the coauthor list',
    lt: 'Choose a member to add to the coauthor list',
    ch: 'Choose a member to add to the coauthor list',
    ph: 'Choose a member to add to the coauthor list',
  },
  'Created Date': {
    en: 'Created Date',
    ja: '作成日',
    et: 'Loomise kuupäev',
    lt: 'Created Date',
    ch: 'Created Date',
    ph: 'Created Date',
  },
  'DELETE! Are you absolutely certain that you want to DELETE this project?': {
    en: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    ja: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    et: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    lt: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    ch: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    ph: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
  },
  'Danger Zone': {
    en: 'Danger Zone',
    ja: 'Danger Zone',
    et: 'Danger Zone',
    lt: 'Danger Zone',
    ch: 'Danger Zone',
    ph: 'Danger Zone',
  },
  'Delete Category': {
    en: 'Delete Category',
    ja: 'Delete Category',
    et: 'Delete Category',
    lt: 'Delete Category',
    ch: 'Delete Category',
    ph: 'Delete Category',
  },
  'Delete Project': {
    en: 'Delete Project',
    ja: 'Delete Project',
    et: 'Delete Project',
    lt: 'Delete Project',
    ch: 'Delete Project',
    ph: 'Delete Project',
  },
  'Delete this project?': {
    en: 'Delete this project?',
    ja: 'Delete this project?',
    et: 'Delete this project?',
    lt: 'Delete this project?',
    ch: 'Delete this project?',
    ph: 'Delete this project?',
  },
  'Delete category?': {
    en: 'Delete category?',
    ja: 'Delete category?',
    et: 'Delete category?',
    lt: 'Delete category?',
    ch: 'Delete category?',
    ph: 'Delete category?',
  },
  Description: {
    en: 'Description',
    ja: '説明',
    et: 'Kirjeldus',
    lt: 'Description',
    ch: 'Description',
    ph: 'Description',
  },
  Drafts: {
    en: 'Drafts',
    ja: 'Drafts',
    et: 'Drafts',
    lt: 'Drafts',
    ch: 'Drafts',
    ph: 'Drafts',
  },
  'Edit Project Link': {
    en: 'Edit Project Link',
    ja: 'Edit Project Link',
    et: 'Edit Project Link',
    lt: 'Edit Project Link',
    ch: 'Edit Project Link',
    ph: 'Edit Project Link',
  },
  Latest: {
    en: 'Latest',
    ja: 'Latest',
    et: 'Latest',
    lt: 'Latest',
    ch: 'Latest',
    ph: 'Latest',
  },
  Links: {
    en: 'Links',
    ja: 'Links',
    et: 'Links',
    lt: 'Links',
    ch: 'Links',
    ph: 'Links',
  },
  Name: {
    en: 'Name',
    ja: 'Name',
    et: 'Name',
    lt: 'Name',
    ch: 'Name',
    ph: 'Name',
  },
  'New Category': {
    en: 'New Category',
    ja: 'New Category',
    et: 'New Category',
    lt: 'New Category',
    ch: 'New Category',
    ph: 'New Category',
  },
  'No Results': {
    en: 'No Results',
    ja: '結果がありません',
    et: 'Tulemused puuduvad',
    lt: 'No Results',
    ch: 'No Results',
    ph: 'No Results',
  },
  Oldest: {
    en: 'Oldest',
    ja: 'Oldest',
    et: 'Oldest',
    lt: 'Oldest',
    ch: 'Oldest',
    ph: 'Oldest',
  },
  'Only completed project can be approved/rejected for badges': {
    en: 'Only completed project can be approved/rejected for badges',
    ja: 'Only completed project can be approved/rejected for badges',
    et: 'Only completed project can be approved/rejected for badges',
    lt: 'Only completed project can be approved/rejected for badges',
    ch: 'Only completed project can be approved/rejected for badges',
    ph: 'Only completed project can be approved/rejected for badges',
  },
  'Please select at least one user from the dropdown list!': {
    en: 'Please select at least one user from the dropdown list!',
    ja: 'Please select at least one user from the dropdown list!',
    et: 'Please select at least one user from the dropdown list!',
    lt: 'Please select at least one user from the dropdown list!',
    ch: 'Please select at least one user from the dropdown list!',
    ph: 'Please select at least one user from the dropdown list!',
  },
  'Project Admin Notes': {
    en: 'Project Admin Notes',
    ja: 'Project Admin Notes',
    et: 'Project Admin Notes',
    lt: 'Project Admin Notes',
    ch: 'Project Admin Notes',
    ph: 'Project Admin Notes',
  },
  'Project Approved': {
    en: 'Project Approved',
    ja: 'Project Approved',
    et: 'Project Approved',
    lt: 'Project Approved',
    ch: 'Project Approved',
    ph: 'Project Approved',
  },
  'Project Authors': {
    en: 'Project Authors',
    ja: 'Project Authors',
    et: 'Project Authors',
    lt: 'Project Authors',
    ch: 'Project Authors',
    ph: 'Project Authors',
  },
  'Project Authors Changed!': {
    en: 'Project Authors Changed!',
    ja: 'Project Authors Changed!',
    et: 'Project Authors Changed!',
    lt: 'Project Authors Changed!',
    ch: 'Project Authors Changed!',
    ph: 'Project Authors Changed!',
  },
  'Project Owner Changed!': {
    en: 'Project Owner Changed!',
    ja: 'Project Owner Changed!',
    et: 'Project Owner Changed!',
    lt: 'Project Owner Changed!',
    ch: 'Project Owner Changed!',
    ph: 'Project Owner Changed!',
  },
  'Project Data': {
    en: 'Project Data',
    ja: 'Project Data',
    et: 'Project Data',
    lt: 'Project Data',
    ch: 'Project Data',
    ph: 'Project Data',
  },
  'Project Deleted': {
    en: 'Project Deleted',
    ja: 'Project Deleted',
    et: 'Project Deleted',
    lt: 'Project Deleted',
    ch: 'Project Deleted',
    ph: 'Project Deleted',
  },
  'Project Filters': {
    en: 'Project Filters',
    ja: 'Project Filters',
    et: 'Project Filters',
    lt: 'Project Filters',
    ch: 'Project Filters',
    ph: 'Project Filters',
  },
  'Project Link': {
    en: 'Project Link',
    ja: 'Project Link',
    et: 'Project Link',
    lt: 'Project Link',
    ch: 'Project Link',
    ph: 'Project Link',
  },
  'Project Ownership': {
    en: 'Project Ownership',
    ja: 'Project Ownership',
    et: 'Project Ownership',
    lt: 'Project Ownership',
    ch: 'Project Ownership',
    ph: 'Project Ownership',
  },
  'Project Rejected': {
    en: 'Project Rejected',
    ja: 'Project Rejected',
    et: 'Project Rejected',
    lt: 'Project Rejected',
    ch: 'Project Rejected',
    ph: 'Project Rejected',
  },
  'Project Status': {
    en: 'Project Status',
    ja: 'Project Status',
    et: 'Project Status',
    lt: 'Project Status',
    ch: 'Project Status',
    ph: 'Project Status',
  },
  'Project category added': {
    en: 'Project category added',
    ja: 'Project category added',
    et: 'Project category added',
    lt: 'Project category added',
    ch: 'Project category added',
    ph: 'Project category added',
  },
  'Project category deleted': {
    en: 'Project category deleted',
    ja: 'Project category deleted',
    et: 'Project category deleted',
    lt: 'Project category deleted',
    ch: 'Project category deleted',
    ph: 'Project category deleted',
  },
  'Project category edited': {
    en: 'Project category edited',
    ja: 'Project category edited',
    et: 'Project category edited',
    lt: 'Project category edited',
    ch: 'Project category edited',
    ph: 'Project category edited',
  },
  Projects: {
    en: 'Projects',
    ja: 'プロジェクト',
    et: 'Projektid',
    lt: 'Projects',
    ch: 'Projects',
    ph: 'Projects',
  },
  Reject: {
    en: 'Reject',
    ja: 'Reject',
    et: 'Reject',
    lt: 'Reject',
    ch: 'Reject',
    ph: 'Reject',
  },
  'Requested badges are rejected. Author needs to edit and re-submit request of badges': {
    en: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
    ja: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
    et: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
    lt: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
    ch: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
    ph: 'Requested badges are rejected. Author needs to edit and re-submit request of badges',
  },
  Save: {
    en: 'Save',
    ja: '保存',
    et: 'Salvesta',
    lt: 'Save',
    ch: 'Save',
    ph: 'Save',
  },
  Search: {
    en: 'Search',
    ja: '探す',
    et: 'Otsing',
    lt: 'Search',
    ch: 'Search',
    ph: 'Search',
  },
  'Search Projects': {
    en: 'Search Projects',
    ja: 'Search Projects',
    et: 'Search Projects',
    lt: 'Search Projects',
    ch: 'Search Projects',
    ph: 'Search Projects',
  },
  'Select Users': {
    en: 'Select Users',
    ja: 'Select Users',
    et: 'Select Users',
    lt: 'Select Users',
    ch: 'Search Users',
    ph: 'Search Users',
  },
  'Updated Date': {
    en: 'Updated Date',
    ja: '編集された日付',
    et: 'Muutmise kuupäev',
    lt: 'Updated Date',
    ch: 'Updated Date',
    ph: 'Updated Date',
  },
  'Will go live right away if approved': {
    en: 'Will go live right away if approved',
    ja: 'Will go live right away if approved',
    et: 'Will go live right away if approved',
    lt: 'Will go live right away if approved',
    ch: 'Will go live right away if approved',
    ph: 'Will go live right away if approved',
  },
  'Work In Progress': {
    en: 'Work In Progress',
    ja: 'Work In Progress',
    et: 'Work In Progress',
    lt: 'Work In Progress',
    ch: 'Work In Progress',
    ph: 'Work In Progress',
  },
  'You are unauthorized to approve or reject project': {
    en: 'You are unauthorized to approve or reject project',
    ja: 'You are unauthorized to approve or reject project',
    et: 'You are unauthorized to approve or reject project',
    lt: 'You are unauthorized to approve or reject project',
    ch: 'You are unauthorized to approve or reject project',
    ph: 'You are unauthorized to approve or reject project',
  },
  awarded: {
    en: 'awarded',
    ja: 'awarded',
    et: 'awarded',
    lt: 'awarded',
    ch: 'awarded',
    ph: 'awarded',
  },
  rejected: {
    en: 'rejected',
    ja: 'rejected',
    et: 'rejected',
    lt: 'rejected',
    ch: 'rejected',
    ph: 'rejected',
  },
  resubmitted: {
    en: 'resubmitted',
    ja: 'resubmitted',
    et: 'resubmitted',
    lt: 'resubmitted',
    ch: 'resubmitted',
    ph: 'resubmitted',
  },
  submitted: {
    ja: 'submitted',
    en: 'submitted',
    et: 'submitted',
    lt: 'submitted',
    ch: 'submitted',
    ph: 'submitted',
  },
  title: {
    en: 'title',
    ja: 'title',
    et: 'title',
    lt: 'title',
    ch: 'title',
    ph: 'title',
  },
  unsubmitted: {
    en: 'unsubmitted',
    ja: 'unsubmitted',
    et: 'unsubmitted',
    lt: 'unsubmitted',
    ch: 'unsubmitted',
    ph: 'unsubmitted',
  },
  username: {
    en: 'username',
    ja: 'ユーザー名',
    et: 'kasutajanimi',
    lt: 'username',
    ch: 'username',
    ph: 'username',
  },
  'Save Authors': {
    en: 'Save Authors',
    ja: 'Save Authors',
    et: 'Save Authors',
    lt: 'Save Authors',
    ch: 'Save Authors',
    ph: 'Save Authors',
  },
  'Change Project Owner': {
    en: 'Change Project Owner',
    ja: 'Change Project Owner',
    et: 'Change Project Owner',
    lt: 'Change Project Owner',
    ch: 'Change Project Owner',
    ph: 'Change Project Owner',
  },
  'Change Owner': {
    en: 'Change Owner',
    ja: 'Change Owner',
    et: 'Change Owner',
    lt: 'Change Owner',
    ch: 'Change Owner',
    ph: 'Change Owner',
  },
  'Choose a member to overwrite the current owner': {
    en: 'Choose a member to overwrite the current owner',
    ja: 'Choose a member to overwrite the current owner',
    et: 'Choose a member to overwrite the current owner',
    lt: 'Choose a member to overwrite the current owner',
    ch: 'Choose a member to overwrite the current owner',
    ph: 'Choose a member to overwrite the current owner',
  },
};
